export const APP_STORE = 'https://apps.apple.com/ua/app/leobank/id1574700070';
export const PLAY_MARKET = 'https://play.google.com/store/apps/details?id=com.ftfarm.leo';
export const DEFAULT_LANG = 'az';
